        <!-- DeviceParam HJ212参数设置 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="deviceParam">
      <div class="deviceParam_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>HJ212参数设置</h1>
      <div class="deviceParam_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>
    <div v-show="true">
      <!-- 查询条件 -->
      <div class="deviceParam_query clearfix">
        <div class="query_list clearfix fl">
          <span class="fl">归属机构：</span>
          <el-cascader
            class="fl"
            :clearable="true"
            v-model="value"
            :checkStrictly="true"
            :options="options"
            placeholder="系统管理机构"
            filterable
            :props="{ expandTrigger: 'hover', checkStrictly: true }"
            @change="handleChange"
          ></el-cascader>
        </div>
        <div class="query_list clearfix fl">
          <span class="fl">在线状态：</span>
          <el-select clearable v-model="online" placeholder="请选择">
            <el-option
              v-for="item in onlineList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="query_list clearfix fl">
          <span class="fl">设备编号：</span>
          <div class="fl">
            <el-input
              placeholder="请输入内容"
              v-model="innerCode"
              clearable
            ></el-input>
          </div>
        </div>
        <div class="query_list clearfix fl">
          <span class="fl">采集点：</span>
          <div class="fl">
            <el-input
              placeholder="请输入采集点"
              v-model="deviceName"
              clearable=""
            ></el-input>
          </div>
        </div>

        <el-button type="primary" @click="queryClick()" icon="el-icon-search">
          查询
        </el-button>
      </div>

      <div class="deviceParam_title">
        <el-row>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">归属机构</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">采集点名称</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">设备编号</div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="">状态</div>
          </el-col>
          <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
            <div class="">有效数据项</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">操作</div>
          </el-col>
        </el-row>
      </div>
      <div v-show="list.length > 0">
        <div
          class="deviceParam_list"
          v-for="(item, index) in list"
          :key="index"
        >
          <el-row>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceParam_tab">
                {{
                  item.deptId == "100000000" ? "系统管理机构" : map[item.deptId]
                }}
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceParam_tab">{{ item.deviceName }}</div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceParam_tab">{{ item.innerCode }}</div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
              <div class="deviceParam_tab">
                {{ item.online == "0" ? "离线" : "在线" }}
              </div>
            </el-col>
            <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
              <div class="deviceParam_tab">
                {{ item.fields }}
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceParam_tab" @click="tabClick(index)">
                设置数据项
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="deviceParam_btn">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>

      <div v-show="list.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <!-- 选择机构 -->
    <el-drawer
      title="HJ212参数设置"
      size="60%"
      :modal="false"
      :visible.sync="drawer"
      :modal-append-to-body="false"
    >
      <div class="drawer_box">
        <div class="drawer_top">
          <span>归属机构：{{ map[equipment.deptId] }}</span>
          <span>设备名称：{{ equipment.deviceName }}</span>
          <span>设备编号：{{ equipment.innerCode }}</span>
        </div>

        <div class="drawer_text clearfix">
          <p class="fl">原始数据：</p>
          <p class="fl">{{ original }}</p>
        </div>

        <div class="drawer_query clearfix">
          <div class="query_list clearfix fl">
            <span class="fl">显示模板：</span>
            <el-select v-model="tmplsValue" clearable placeholder="请选择">
              <el-option
                v-for="item in tmpls"
                :key="item.queryrowid"
                :label="item.tmplName"
                :value="item.queryrowid"
              >
              </el-option>
            </el-select>
          </div>
          <div class="query_list clearfix fl">
            <span class="fl">字段：</span>
            <div class="fl">
              <el-input
                placeholder="请输入内容"
                v-model="field"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="query_list clearfix fl">
            <span class="fl">描述：</span>
            <div class="fl">
              <el-input
                placeholder="请输入内容"
                v-model="describe"
                clearable
              ></el-input>
            </div>
          </div>
        </div>

        <div class="drawer_btns clearfix">
          <el-button
            class="fr"
            type="primary"
            @click="saveAsClick()"
            icon="el-icon-folder-opened"
            >另存为模板</el-button
          >
          <el-button
            class="fr"
            type="primary"
            @click="saveClick()"
            icon="el-icon-folder"
            >保存</el-button
          >
          <el-button
            class="fr"
            type="primary"
            @click="addClick()"
            icon="el-icon-plus"
            >新增</el-button
          >
        </div>

        <div class="drawer_content">
          <el-row class="drawer_title">
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">序号</el-col>
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">数据名称</el-col>
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">数据描述</el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">计量单位</el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">下限值</el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">上限值</el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">使用状态</el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">操作</el-col>
          </el-row>

          <div v-show="equipmentList.length > 0">
            <el-row
              class="drawer_list"
              v-for="(item, index) in equipmentList"
              :key="index"
            >
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <input type="text" value="" v-model="item.serialNum" />
              </el-col>
              <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                <input type="text" v-model="item.dataName" />
              </el-col>
              <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                <input type="text" v-model="item.dataDesc" />
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <input type="text" v-model="item.measUnit" />
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <input type="text" v-model="item.minValue" />
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <input type="text" v-model="item.maxValue" />
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <select v-model="item.enable">
                  <option value="0">停用</option>
                  <option value="1">启用</option>
                </select>
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <p @click="shanClick(index)">删除</p>
              </el-col>
            </el-row>
          </div>
          <div v-show="equipmentList.length == 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>

        <div class="drawer_lists">
          <h1>最后10条原始数据（最后一条为最新）</h1>

          <div class="drawer_list_title clearfix">
            <p class="fl">序号</p>
            <p class="fl">数据内容</p>
          </div>
          <div v-show="lastDatas.length > 0">
            <div
              class="drawer_list_list clearfix"
              v-for="(item, index) in lastDatas"
              :key="index"
            >
              <p class="fl">{{ index + 1 }}</p>
              <p class="fl">{{ item }}</p>
            </div>
          </div>
          <div v-show="lastDatas.length == 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 内容 -->
    <iframe
      v-show="false"
      class="deviceParam_content"
      :src="apiUrls + '?txcode=DeviceParam'"
      frameborder="0"
    >
    </iframe>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // HJ212参数设置
      drawer: false,
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 机构树
      options: [],
      // 当前选择机构
      value: [],
      // 当前机构ID
      deptId: "",
      // 在线状态
      online: "",
      // 在线状态LIST
      onlineList: [
        {
          value: "0",
          label: "离线",
        },
        {
          value: "1",
          label: "在线",
        },
      ],
      // 设备编号
      deviceName: "",
      // 采集点
      innerCode: "",

      // 当前页数
      page: 1,
      // 总数据数
      total: 0,
      // 嵌入页面路径
      apiUrls: "",
      // HJ212数据
      list: [],

      // 机构映射
      map: {},

      // 设备明细
      equipment: {},
      // 设备明细 参数细分
      equipmentList: {},
      equipmentShow: {},

      // 设备明细 原始数据
      original: "",
      // 最后10条原始数据（最后一条为最新）
      lastDatas: [],

      // 显示模板2

      // 显示模板
      tmpls: [],
      // 选中的采集模板
      tmplsValue: "",
      // 字段
      field: "",
      // 描述
      describe: "",
      // 设备ID
      deviceId: "",

      // 数据项ID集
      ids: "",
    };
  },
  watch: {
    // 监听选择模板
    tmplsValue(v, s) {
      console.log(v, s);
      if (v.length > 0) {
        for (let i = 0; i < this.tmpls.length; i++) {
          if (v == this.tmpls[i].queryrowid) {
            let loginToken = localStorage.getItem("loginToken");
            this.$axios({
              method: "post",
              url: this.api,
              data: {
                txcode: " DataTemplate ", //交易码
                option: "EDIT", //交易选项
                tmplId: this.tmpls[i].tmplId, //模板ID（必填）
                loginToken,
              },
            })
              .then((res) => {
                if (res.data._STATUS == 0) {
                  this.equipmentList = res.data.list;
                } else {
                  // 登录超时，调用全局方法
                  this.loginTimeout();
                }
              })
              .catch((err) => {
                console.log(err, "err");
              });

            break;
          }
        }
      } else {
        this.deviceParamTab(this.deviceId);
      }
    },
  },
  created() {
    this.apiUrls = this.apiUrl;
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取机构树
    this.options = JSON.parse(localStorage.getItem("structure"));

    // 调用HJ212参数设置 获取（查询设备）
    this.DeviceParam();

    // 机构映射
    this.map = JSON.parse(localStorage.getItem("mapTree"));
    // console.log(JSON.parse(localStorage.getItem("mapTree")))
  },
  methods: {
    // 添加参数
    addClick() {
      if (this.field.length > 0 && this.describe.length > 0) {
        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DeviceParam", //交易码
            option: "ADD", //交易选项
            deviceId: this.deviceId, //设备ID（必填）
            dataName: this.field, //数据名称
            dataDesc: this.describe, //数据描述
            loginToken,
          },
        })
          .then((res) => {
            if (res.data._STATUS == 0) {
              this.tmplsValue = "";
              this.field = "";
              this.describe = "";

              this.$notify({
                title: "添加成功",
                position: "top-left",
                type: "success",
              });
              this.deviceParamTab(this.deviceId);
              this.DeviceParam();
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err, "err");
          });
      } else {
        this.$notify({
          title: "字段/描述不能为空",
          position: "top-left",
          type: "warning",
        });
      }
    },
    // 删除参数
    shanClick(index) {
      let isHas = confirm(
        "是否删除数据项" +
          this.equipmentList[index].dataName +
          "/" +
          this.equipmentList[index].dataDesc
      );

      if (isHas == true) {
        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DeviceParam", //交易码
            option: "DEL", //交易选项
            deviceId: this.deviceId, //设备ID（必填）
            dataId: this.equipmentList[index].dataId, //数据项ID
            loginToken,
          },
        })
          .then((res) => {
            if (res.data._STATUS == 0) {
              this.deviceParamTab(this.deviceId);
              this.DeviceParam();
              this.$notify({
                title: "删除成功",
                position: "top-left",
                type: "success",
              });
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err, "err");
          });
      }
    },
    // 保存参数设置
    saveClick() {
      let list = this.ids.split(",");

      let loginToken = localStorage.getItem("loginToken");
      let arr = {
        txcode: "DeviceParam", //交易码
        option: "SAVE", //交易选项
        deviceId: this.deviceId, //设备ID（必填）
        ids: this.ids, //数据项ID集（以下以“_设备ID”为后缀的相同前缀参数个数与集合长度相一致）
        loginToken,
      };

      for (let i = 0; i < list.length; i++) {
        ((i) => {
          for (let j = 0; j < this.equipmentList.length; j++) {
            if (list[i] == this.equipmentList[j].dataId) {
              arr["serialNum_" + list[i]] = list[i];
              arr["dataName_" + list[i]] = this.equipmentList[j].dataName;
              arr["dataDesc_" + list[i]] = this.equipmentList[j].dataDesc;
              arr["measUnit_" + list[i]] = this.equipmentList[j].measUnit;
              arr["minValue_" + list[i]] = this.equipmentList[j].minValue;
              arr["maxValue_" + list[i]] = this.equipmentList[j].maxValue;
              arr["enable_" + list[i]] = this.equipmentList[j].enable;
              arr["category_" + list[i]] = this.equipmentList[j].category;
              arr["yStep_" + list[i]] = this.equipmentList[j].yStep;
              arr["yBase_" + list[i]] = this.equipmentList[j].yBase;
            }
          }
        })(i);
      }

      this.$axios({
        method: "post",
        url: this.api,
        data: arr,
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            this.DeviceParam();
            this.$notify({
              title: "保存成功",
              position: "top-left",
              type: "success",
            });
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },

    // 另存为模板
    saveAsClick() {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeviceParam", //交易码
          option: "AS_TMPL", //交易选项
          deviceId: this.deviceId, //设备ID（必填）
          loginToken,
        },
      })
        .then((res) => {
          console.log(res, "--------");
          if (res.data._STATUS == 0) {
            this.deviceParamTab(this.deviceId);
            this.$notify({
              title: "另存为模板成功",
              position: "top-left",
              type: "success",
            });
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },

    // 数据明细
    tabClick(index) {
      this.drawer = true;
      this.tmplsValue = "";
      this.field = "";
      this.describe = "";
      this.deviceId = this.list[index].deviceId;

      this.deviceParamTab(this.deviceId);
    },
    // DeviceParam明细
    deviceParamTab(deviceId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeviceParam", //交易码
          option: "DETAIL", //交易选项
          deviceId, //设备ID（必填）
          loginToken,
        },
      })
        .then((res) => {
          console.log(res.data, "res.data-----");
          if (res.data._STATUS == 0) {
            this.equipment = res.data.map;
            this.original = res.data.original;
            this.lastDatas = res.data.lastDatas;
            this.tmpls = res.data.tmpls;
            this.equipmentList = res.data.list;
            this.equipmentShow = res.data.list;
            this.deviceId = res.data.deviceId;

            this.ids = res.data.ids;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    // 查询数据
    queryClick() {
      if (
        this.online == "" &&
        this.deviceName == "" &&
        this.innerCode == "" &&
        this.deptId == ""
      ) {
        this.DeviceParam();
      } else {
        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DeviceParam", //交易码
            option: "LIST", //交易选项
            online: this.online, //是否在线
            deptId: this.deptId, //机构ID
            deviceName: this.deviceName, //设备名称
            innerCode: this.innerCode, //设备编号（MN码）
            page: 1, //页码
            loginToken,
          },
        })
          .then((res) => {
            console.log(res, "res");
            if (res.data._STATUS == 0) {
              this.list = res.data.list;
              this.page = 1;
              this.total = res.data.rowsCount;
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err, "err");
          });
      }
    },
    // HJ212参数设置（查询设备）
    DeviceParam() {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeviceParam", //交易码
          option: "LIST", //交易选项
          online: "", //是否在线
          deptId: "", //机构ID
          deviceName: "", //设备名称
          innerCode: "", //设备编号（MN码）
          page: this.page, //页码
          loginToken,
        },
      })
        .then((res) => {
          // console.log(res, "res");
          if (res.data._STATUS == 0) {
            this.list = res.data.list;

            this.total = res.data.rowsCount;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    // 现在所属机构
    handleChange(value) {
      if (value.length == 0) {
        this.patchLists = [];
      }
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
    },

    // 选择分页
    handleCurrentChange(val) {
      // console.log(val);
      this.page = val;
      this.DeviceParam();
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.deviceParam {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .deviceParam_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .deviceParam_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.deviceParam_query {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  .query_list {
    height: 46px;
    line-height: 40px;
    margin-right: 20px;
  }
}

.deviceParam_title {
  width: calc(100% - 30px);
  margin: 0 15px;
  text-align: center;
  color: #fff;
  height: 40px;
  line-height: 40px;
  background-color: #545c64;
}
.deviceParam_list {
  width: calc(100% - 30px);
  margin: 0 15px;
  text-align: center;
  &:nth-child(2n) {
    background-color: #f0faff;
  }
  &:hover {
    cursor: pointer;
    background-color: rgb(253, 246, 238);
  }
  .deviceParam_tab {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    color: #333;
    // box-sizing: border-box;
    min-height: 40px;
  }
}

.deviceParam_btn {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    margin: 0 20px;
    color: #666666;
  }
}

// 内容
.deviceParam_content {
  width: calc(100% - 40px);
  height: calc(100% - 80px);
  position: fixed;
  top: 65px;
  left: 20px;
}

// HJ212参数设置
.drawer_box {
  padding-bottom: 100px;
  .drawer_top {
    width: 100%;
    height: 30px;
    padding: 0px 20px;
    box-sizing: border-box;
    span {
      margin-right: 80px;
    }
  }

  .drawer_text {
    width: 100%;
    padding: 0px 20px;
    margin-bottom: 15px;
    box-sizing: border-box;
    p {
      &:nth-child(1) {
        width: 80px;
      }
      &:nth-child(2) {
        width: calc(100% - 80px);
      }
    }
  }

  .drawer_query {
    width: 100%;
    padding: 0px 20px;
    box-sizing: border-box;
    margin-bottom: 6px;
    .query_list {
      height: 46px;
      line-height: 40px;
      margin-right: 20px;
    }
  }
  // 112.74.33.7
  // 7001
  .drawer_btns {
    width: 100%;
    padding: 0px 15px;
    margin-bottom: 10px;
    box-sizing: border-box;
    .el-button {
      margin-right: 20px;
    }
  }

  .drawer_content {
    width: 100%;
    .drawer_title {
      width: calc(100% - 30px);
      margin: 0 15px;
      text-align: center;
      color: #fff;
      height: 40px;
      line-height: 40px;
      background-color: #545c64;
    }
    .drawer_list {
      width: calc(100% - 30px);
      margin: 0 15px;
      height: 40px;
      // line-height: 40px;
      text-align: center;
      &:nth-child(2n-1) {
        background-color: #f0faff;
      }
      &:hover {
        cursor: pointer;
        background-color: rgb(253, 246, 238);
      }
      input {
        height: 24px;
        width: 80%;
        margin: 7px 0;
        border: 1px solid #ccc;
        text-align: center;
      }
      select {
        text-indent: 10px;
        height: 26px;
        width: 80%;
        margin: 7px 0;
        border: 1px solid #ccc;
      }
      p {
        line-height: 40px;
        text-decoration: underline;
        &:hover {
          color: red;
        }
      }
    }
  }

  .drawer_lists {
    width: 100%;
    padding: 0px 20px;
    margin-top: 20px;
    box-sizing: border-box;
    .drawer_list_title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #fff;
      margin-top: 10px;
      background-color: #545c64;
      p {
        text-align: center;
        &:nth-child(1) {
          width: 80px;
        }
        &:nth-child(2) {
          width: calc(100% - 80px);
        }
      }
    }
    .drawer_list_list {
      width: 100%;
      min-height: 40px;
      display: flex;
      align-items: center;
      &:nth-child(2n-1) {
        background-color: #f0faff;
      }
      p {
        padding: 5px 0;
        box-sizing: border-box;
        text-align: center;
        &:nth-child(1) {
          width: 80px;
        }
        &:nth-child(2) {
          width: calc(100% - 80px);
        }
      }
    }
  }
}
</style>